import {
  Tv,
  Eye,
  MessageCircle,
  Heart,
  Clapperboard,
  TrendingUp,
  Sparkles,
  ShieldCheck,
} from "lucide-react";
import { Stagger, StaggerItem } from "@/components/motion";
import { ROI_DISCLAIMER } from "@/data/content";

const ICONS = {
  Tv,
  Eye,
  MessageCircle,
  Heart,
  Clapperboard,
  TrendingUp,
  Sparkles,
  ShieldCheck,
};

// Rejilla de 6 ejemplos de ROI estimado por episodio (marcas o patrocinadores).
export const RoiGrid = ({ items, accent = "#81D4FA" }) => (
  <div data-testid="roi-grid">
    <Stagger className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {items.map((m, i) => {
        const Icon = ICONS[m.icon] || TrendingUp;
        return (
          <StaggerItem
            key={i}
            data-testid={`roi-card-${i}`}
            className="flex flex-col rounded-[1.5rem] bg-white p-6 shadow-[0_8px_30px_rgb(0,0,0,0.05)]"
          >
            <span
              className="flex h-11 w-11 items-center justify-center rounded-xl"
              style={{ backgroundColor: `${accent}22` }}
            >
              <Icon className="h-5 w-5" strokeWidth={2.2} style={{ color: accent }} />
            </span>
            <p
              className="mt-5 font-display text-3xl font-extrabold tracking-tight text-ink"
              data-testid={`roi-value-${i}`}
            >
              {m.value}
            </p>
            <p className="mt-1 font-mono text-[11px] uppercase tracking-widest text-ink/40">
              {m.unit}
            </p>
            <p className="mt-3 text-sm font-bold text-ink">{m.label}</p>
            <p className="mt-1.5 flex-1 text-sm leading-relaxed text-ink/60">{m.desc}</p>
          </StaggerItem>
        );
      })}
    </Stagger>
    <p
      className="mt-8 max-w-3xl text-xs italic leading-relaxed text-ink/40"
      data-testid="roi-disclaimer"
    >
      {ROI_DISCLAIMER}
    </p>
  </div>
);
